import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './animation.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';
import {QueryClientProvider,QueryClient} from 'react-query';
import {Provider} from 'jotai';
import { ModalContextProvider,NotificaitonContextProvider } from './context';
import appStore from './store';
const queryClient = new QueryClient;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChakraProvider >
      <QueryClientProvider client={queryClient}>
        <Provider store={appStore}>
          <NotificaitonContextProvider>
            <ModalContextProvider>
              <Router>
                <Routes>
                  <Route path="*" element={<App />}/>
                </Routes>
              </Router>
            </ModalContextProvider>
          </NotificaitonContextProvider>
          
        </Provider>
       
      </QueryClientProvider>
      
    </ChakraProvider>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
